// Reads the intrinsic (natural) pixel dimensions of an image without
// committing it to the DOM. Works for data URLs (no network) and HTTP URLs
// (single fetch — typically already in the browser's image cache by the
// time the renderer asks for the image). Used by the send-side image
// attachment capture and by `EmbedResolverService` after OGP returns an
// image URL — in both cases the dims travel through the storage shape so
// the renderer can apply `<img width height>` and the browser reserves
// the correct aspect-ratio box before the image actually decodes.
export function imageDimensions(src: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = reject;
    img.src = src;
  });
}
